import React from 'react'
import styles from './styles.css'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import Button from 'orionsoft-parts/lib/components/Button'
import {Form, Field} from 'simple-react-form'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import autobind from 'autobind-decorator'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import PropTypes from 'prop-types'
import moment from 'moment'
// import {isMobile} from 'src/App/components/Devices/mediaCheckers'
// import Paginated from 'meteor-paginated-graphql-react'
// import Loading from 'orionsoft-parts/lib/components/Loading'
// import DraftIcon from 'react-icons/lib/md/description'

@withGraphQL(gql`
  query userPlan {
    userPlan {
      initDate
      endDate
      period {
        initDate
        endDate
        simpleSignatures {
          documentId
          signatureId
        }
        advancedSignatures {
          documentId
        }
      }
      plan {
        name
        simpleSignatures
        advancedSignatures
      }
    }
  }
`)

@withGraphQL(gql`
  query userSignaturesPacks {
    userSignaturesPacks {
        _id
        initDate
        signaturePack {
          name
          simpleSignatures
          advancedSignatures
        }
        simpleSignatures {
          documentId
          signatureId
        }
        advancedSignatures {
          signatureId
        }
    }
  }
`)

@withMessage
export default class FirmasDigitales extends React.Component {

  state = {
    permitePagar: true
  }
  static propTypes = {
    userPlan: PropTypes.object,
    userSignaturesPacks: PropTypes.object
    
  }

  @autobind
  async save(profile) {
    this.setState({loading: false})
  }

  formatFecha(fechaInt) {
    if(!fechaInt)
      return " - "
    return moment(fechaInt).format('DD/MM/YYYY')
  }

  // getFields() {
  //   if (isMobile()) {
  //     return [
  //       {title: '', name: '_id', render: () => <DraftIcon size={20} />},
  //       {title: 'Nombre', name: 'name'}
  //     ]
  //   }
  //     return[
  //       {title: 'Nombre', name: 'signaturePack{name}', },
  //       {title: 'Fecha de compra', name: 'createdAt', render: ({createdAt}) => moment(createdAt).format('DD/MM/YYYY')},
  //       {title: 'Disponibles Hasta', name: 'endDate',render: ({endDate}) => moment(endDate).format('DD/MM/YYYY')},
  //       {title: 'Simples', name: 'signaturePack{simpleSignatures}',},
  //       {title: 'Avanzadas', name: 'signaturePack{advancedSignatures}'},
  //     ]
  // }

  renderListaPaquetes(packsDeFirmas){
      
      return packsDeFirmas.map( packDeFirmas => {
        console.log("Jugando con pack: ", packDeFirmas);
        if(!packDeFirmas.signaturePack){
          return null;
        }
        let firmasSimples = packDeFirmas.signaturePack.simpleSignatures
        let firmasAvanzadas = packDeFirmas.signaturePack.advancedSignatures
        let simplesUsadas = packDeFirmas.simpleSignatures? packDeFirmas.simpleSignatures.length : 0;
        let avanzadasUsadas = packDeFirmas.advancedSignatures? packDeFirmas.advancedSignatures.length : 0;
        return (
          <tr style={{ cursor: 'pointer' }}>
            <td>{packDeFirmas.signaturePack.name}</td>
            <td>{this.formatFecha(packDeFirmas.initDate)}</td>
            <td>{this.formatFecha(packDeFirmas.endDate)}</td>
            <td>{ simplesUsadas + " / " + firmasSimples }</td>
            <td>{ avanzadasUsadas + " / " + firmasAvanzadas }</td>
          </tr>
        )
      })
  }

  renderListadoPaqueteDeFirmas(){
    if(this.props.userSignaturesPacks && this.props.userSignaturesPacks.length > 0){
      return (
        <div className="paginated-table table hoverable">
          <table>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Fecha Compra</th>
                <th>Disponibles Hasta</th>
                <th>Simples</th>
                <th>Avanzadas</th>
              </tr>
            </thead>
            <tbody>
              { this.renderListaPaquetes(this.props.userSignaturesPacks) }
              {/* <Paginated
              loadingComponent={Loading}
              queryName="paginatedUserPack"
              fields={this.getFields()}
              params="$filter: String $userId: String"
              userId={this.props.userId}
              onPress={this.onSelect}
              /> */}
            </tbody>
          </table>
        </div>
      )
    } else {
      return (
        <div className={styles.noTable}>
          <p>Usted no tiene paquetes de firma disponibles</p>
          
        </div>
      )
    }
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <h3 className={styles.title}>Firmas Digitales</h3>
          </div>
          <div className="content">
            <Form
              errorMessages={this.state.errorMessages}
              ref={form => {
                this.form = form
              }}
              onSubmit={this.save}
            >
              <span>Tu plan es: </span>
              <span><b>{this.props.userPlan.plan.name}</b></span>
              <p>Periodo entre { this.formatFecha(this.props.userPlan.period.initDate) } y { this.formatFecha(this.props.userPlan.period.endDate) }</p>

              <div className="label">Firmas Simples del Periodo</div>
              <Field fieldName="phone" placeholder="Telefono" disabled type={Text} 
                value={ this.props.userPlan.period.simpleSignatures.length + ' / ' + this.props.userPlan.plan.simpleSignatures }/>

              <div className="label">Firmas Avanzadas del Periodo</div>
              <Field fieldName="phone" placeholder="Telefono" disabled type={Text} 
                value={ this.props.userPlan.period.advancedSignatures.length + ' / ' + this.props.userPlan.plan.advancedSignatures } />

                <br />
                <div className="section">
                    <div className="header">
                      <h1 className={styles.noTable}>Paquetes de Firmas Disponibles</h1>
                    </div>
                    {this.renderListadoPaqueteDeFirmas()}
                </div>
            </Form>
            
            {
            <Button loading={this.state.loading} primary  onClick={() => this.props.router.push(`/settings/payments/availablePacks`) } >
              Comprar Firmas
            </Button>
            /*
           <Button loading={this.state.loading} primary  onClick={() => 
            window.location.href="mailto:ventas@tufirma.digital?subject=Comprar%20Firmas&body=Mi usuario en tu firma es:" } >
            Comprar Firmas
          </Button>
            */
            }
            
            <Button loading={this.state.loading} primary onClick={() => 
              window.location.href="mailto:ventas@tufirma.digital?subject=Cambio%20de%20Plan&body=Mi usuario en tu firma es:" } >
              Cambiar Plan
            </Button>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Settings/FirmasDigitales/index.js